import React from 'react';
import Picker, { setDefaultLocale } from 'react-datepicker';
import { IDatePicker } from './interfaces';
import TodayIcon from '@material-ui/icons/Today';
import { TextField } from '@material-ui/core';
import { useStyles } from './styles';
import { Controller } from 'react-hook-form';

setDefaultLocale('pt-br');

export const DatePicker = (props: IDatePicker) => {
  const { label, minDate, variant, control, name, defaultValue, className } = props;
  const classes = useStyles();

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <div className={classes.root}>
          <Picker
            selected={value}
            minDate={minDate || null}
            dateFormat="dd/MM/yyyy"
            onChange={(date) => onChange(date)}
            customInput={
              <TextField
                className={className}
                variant={variant || 'standard'}
                label={label}
                placeholder="dd/mm/aaaa"
                value={value}
                fullWidth
                error={!!error}
                helperText={error?.message || null}
                InputProps={{
                  endAdornment: <TodayIcon />
                }}
              />
            }
          />
        </div>
      )}
    />
  );
};
